import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  switchLabelWrapperWithAmount: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  containerWithAmount: {
    width: `calc(100% - ${theme.spacing(8)})`,
  },

  label: {
    color: theme.palette.neutral.main,
    ...theme.typography.inputText,

    '&:not(:only-child)': {
      color: theme.palette.neutral.dark,
      marginBottom: theme.spacing(1),
    },

    '& span': {
      // TODO: set light font weight
      color: theme.palette.neutral.light,
    },

    '&.has-gutterBottomSmall': { marginBottom: theme.spacing(0.5) },
  },

  subLabel: {
    width: '100%',
    display: 'inline !important',
    overflow: 'unset !important',
    whiteSpace: 'initial !important',
    color: theme.palette.neutral.main,
    ...theme.typography.label,
  },

  checked: {
    fontWeight: 'bold',
  },

  disabled: {
    '&$label': {
      color: theme.palette.neutral.lighter,

      '&:not(:only-child)': {
        color: theme.palette.neutral.light,
      },
    },

    '&$subLabel': {
      color: theme.palette.neutral.light,
    },
  },
}))

export default useStyles
